import HTTP from '../common/http-common';

const END_POINT = '/part';

const listParts = () => HTTP.get(END_POINT);
const isExistPartsCode = (partsCode, partsId) => HTTP.get(END_POINT +  "/exist/" + partsCode + "/" + partsId);
const insertParts = (data) => HTTP.post(END_POINT, {
    partsCode: data.partsCode,
    partsName: data.partsName,
    modelCode : data.modelCode,
    brandCode : data.brandCode,
    unitPrice : data.unitPrice
});
const updateParts = (data) => HTTP.post(END_POINT + "/" + data.partsId, {
    partsCode: data.partsCode,
    partsName: data.partsName,
    modelCode : data.modelCode,
    brandCode : data.brandCode,
    unitPrice : data.unitPrice
});
const deleteParts = (partsId) => HTTP.delete(END_POINT + "/" + partsId);

export {
    listParts,
    isExistPartsCode,
    insertParts,
    updateParts,
    deleteParts
}